module.exports = __webpack_public_path__ + "img/industries_news_light_2.e81fb8b6.png";